import React, { useEffect } from "react";
import "./css/tailwind.css";
import { BrowserRouter as Router, HashRouter, Routes, Route, Redirect } from "react-router-dom";
import Header from "./layouts/Header.js";
import Home from "./pages/Home.js";
import AboutUs from "./pages/AboutUs.js";
import Legacy from "./pages/Legacy.js";
import Footer from "./layouts/Footer.js";
import Products from "./containers/Products";
import Product from "./components/Product";
import ContactUs from "./pages/ContactUs";
import Career from "./pages/Career";
import ScrollToTop from "./components/ScrollToTop";
import { HashLink } from 'react-router-hash-link';
import "react-responsive-carousel/lib/styles/carousel.min.css";

import Aos from "aos";
import "aos/dist/aos.css";

const App = () => {
  useEffect(() => {
    Aos.init({ duration: 600 });
  }, [])

  return (
    <>
      <HashRouter>
        <ScrollToTop />
        <Header />
        <div className="lg:mt-32 mt-16">
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/about-us" element={<AboutUs />} />
            <Route exact path="/legacy" element={<Legacy />} />
            <Route exact path="/products" element={<Products />} />
            <Route exact path="/product/:id" element={<Product />} />
            <Route exact path="/careers" element={<Career />} />
            <Route exact path="/contact-us" element={<ContactUs />} />
            <Route path="*" element={<Home />} >
            </Route>
          </Routes>

        </div>
        <div className="fixed bottom-4 lg:bottom-8 z-50 right-4 lg:right-8 ">
          <button className="rounded-full bg-dinshaw-theme h-12 lg:h-16 w-12 lg:w-16 lg:p-4 shadow-cta">
            <HashLink to="/contact-us#enquiry"><img src="/assets/static/images/Home page-04.png" className='px-2 lg:p-0 text-slate-300 hover:text-white' ></img></HashLink>
          </button>
        </div>
        <Footer />
      </HashRouter>

    </>
  );


};
export default App;

